module.exports = __webpack_public_path__ + "images/external_images/svg/preloaders/slick-carousel-preloader-primary.svg";